/**
 * Search page JS — scoped to body.search
 *
 * Handles:
 * - Re-focusing the search input after each Sprig swap
 * - GA4 live-search tracking (debounced)
 * - Keyboard navigation (↑/↓ through results, Enter to open)
 * - Saving queries to localStorage (consumed by Alpine eaukSearch() component)
 * - Loading bar on plain GET form submit (no-JS degradation path)
 */
(function ($) {
	if (!$('body.search').length) return;

	const LS_KEY = 'eauk_recent_searches';
	const MAX_RECENT = 10;

	// ── Re-focus input after Sprig swaps ───────────────────────────────────
	document.addEventListener('htmx:afterSettle', function () {
		const input = document.getElementById('search-q');
		if (!input) return;
		if (document.activeElement === document.body || document.activeElement === null) {
			const len = input.value.length;
			input.focus();
			try { input.setSelectionRange(len, len); } catch (e) {}
		}
	});

	// ── Save search to recent history on each Sprig request ────────────────
	document.addEventListener('htmx:beforeRequest', function () {
		const input = document.getElementById('search-q');
		if (!input || input.value.trim().length < 2) return;
		const term = input.value.trim();
		let recent = [];
		try { recent = JSON.parse(localStorage.getItem(LS_KEY) || '[]'); } catch (e) {}
		recent = [term, ...recent.filter(function (t) { return t !== term; })].slice(0, MAX_RECENT);
		try { localStorage.setItem(LS_KEY, JSON.stringify(recent)); } catch (e) {}
	});

	// ── GA4 live-search tracking (fires 1s after user stops typing) ─────────
	var gaTimer;
	document.addEventListener('htmx:beforeRequest', function () {
		if (!window.dataLayer) return;
		clearTimeout(gaTimer);
		var input = document.getElementById('search-q');
		if (!input) return;
		var q = input.value.trim();
		gaTimer = setTimeout(function () {
			if (q.length > 1) {
				window.dataLayer.push({
					event: 'GAEvent',
					event_category: 'search_live',
					event_action: undefined,
					event_label: q,
					event_value: undefined,
					nonInteraction: false,
				});
			}
		}, 1000);
	});

	// ── Keyboard navigation (↑/↓ through results, Enter to open) ──────────
	var focusedIndex = -1;

	document.addEventListener('keydown', function (e) {
		var results = document.querySelectorAll('.js-search-result-link');
		var input = document.getElementById('search-q');
		if (!results.length) return;

		if (e.key === 'ArrowDown') {
			e.preventDefault();
			focusedIndex = Math.min(focusedIndex + 1, results.length - 1);
			results[focusedIndex].focus();
		} else if (e.key === 'ArrowUp') {
			e.preventDefault();
			if (focusedIndex <= 0) {
				focusedIndex = -1;
				if (input) input.focus();
			} else {
				focusedIndex = focusedIndex - 1;
				results[focusedIndex].focus();
			}
		} else if (e.key === 'Escape') {
			focusedIndex = -1;
			if (input) input.focus();
		}
	});

	document.addEventListener('htmx:afterSettle', function () {
		focusedIndex = -1;
	});

	// ── Loading bar on plain GET form submit (no-JS degradation path) ───────
	$(document).on('submit', 'form[role="search"]', function () {
		if (typeof showLoadingBar === 'function') showLoadingBar();
	});

})(jQuery);

/**
 * Alpine.js component for the recent-searches panel.
 * Registered as window.eaukSearch so x-data="eaukSearch()" works globally.
 */
window.eaukSearch = function () {
	var LS_KEY = 'eauk_recent_searches';
	return {
		recentSearches: [],
		showRecent: false,
		init: function () {
			var self = this;
			try {
				self.recentSearches = JSON.parse(localStorage.getItem(LS_KEY) || '[]');
			} catch (e) {
				self.recentSearches = [];
			}
			var input = document.getElementById('search-q');
			var hasQuery = input && input.value.trim().length > 0;
			self.showRecent = !hasQuery && self.recentSearches.length > 0;

			document.addEventListener('htmx:afterSettle', function () {
				try { self.recentSearches = JSON.parse(localStorage.getItem(LS_KEY) || '[]'); } catch (e) {}
				var inp = document.getElementById('search-q');
				self.showRecent = inp && inp.value.trim().length === 0 && self.recentSearches.length > 0;
			});
		},
		fillSearch: function (term) {
			var input = document.getElementById('search-q');
			if (!input) return;
			input.value = term;
			this.showRecent = false;
			input.dispatchEvent(new Event('input', { bubbles: true }));
		},
		clearRecent: function () {
			try { localStorage.removeItem(LS_KEY); } catch (e) {}
			this.recentSearches = [];
			this.showRecent = false;
		},
	};
};
